export const ROUTE = {
  ACCOUNT_REGISTRATION: '/account-registration',
  AUTH: {
    SIGN_IN: '/auth/sign-in',
    SIGN_UP: '/auth/sign-up',
    US_SIGN_IN: '/auth/sign-in/us',
    US_SIGN_UP: '/auth/sign-up/us',
    FORGOT_PASSWORD: '/auth/forgot-password',
    ACTION: '/auth/action',
    VERIFY_EMAIL: '/auth/verify-email',
  },
  ROOT: '/',
  FROZEN: '/frozen',
  FEES: '/fees',
  SETTINGS: '/settings',
  TRANSACTION: '/transactions',
  PROFILE: '/profile',
  BUY: '/mint-and-burn',
  PITEAS: '/buy-and-sell',
  HEX: '/hex',
  L_EARN: '/l-earn',
  PORTFOLIO: '/portfolio',
  ANALYTICS: '/analytics',
}
